import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './MovuRobotics.frontend.types'

@Injectable({ providedIn: 'root' })
export class MovuRobotics_execute_shipment_download_requestService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { orderId?: number, shipmentId?: number, warehouseId?: number }): Promise<{ outputDetails?: string[] }> 
  {
    let $url = `${environment.backendUrl}api/outbound/shipment-download`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

